import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70572af5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white text-sm font-bold font-sans mt-5 text-center" }, " Vibe text: ", -1))
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = { class: "grid justify-items-center mt-8 mb-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center font-sans" }, "Metaplex NFT — MP4 + PNG", -1))
const _hoisted_6 = { class: "text-xl text-white font-sans grid justify-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 font-bold" }, " Mint successful! 🎉 ", -1))
const _hoisted_8 = {
  key: 0,
  class: "mt-5 font-bold text-center"
}
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StdNotifications = _resolveComponent("StdNotifications")!
  const _component_NFTViewCard = _resolveComponent("NFTViewCard")!
  const _component_NotifySuccess = _resolveComponent("NotifySuccess")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isConnected && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mintNewMaster && _ctx.mintNewMaster(...args)), ["prevent"]))
        }, [
          _hoisted_1,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "text",
              class: "mt-5 font-sans text-3xl bg-transparent w-full text-center text-white",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
              placeholder: _ctx.DEFAULTS.TEXT
            }, null, 8, _hoisted_2), [
              [_vModelText, _ctx.text]
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["inline-flex justify-center py-2 px-4 border border-transparent shadow-lg font-medium rounded-full text-black font-bold bg-white ring-1 fring-offset-2 ring-black", { 'is-disabled': _ctx.isLoading || !_ctx.isConnected }]),
              disabled: _ctx.isLoading || !_ctx.isConnected,
              type: "submit"
            }, " Mint new Master NFT ", 10, _hoisted_4)
          ]),
          _hoisted_5
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_StdNotifications, {
      "is-connected": _ctx.isConnected,
      "is-minted": _ctx.isMinted,
      "is-loading": _ctx.isLoading,
      error: _ctx.error
    }, null, 8, ["is-connected", "is-minted", "is-loading", "error"]),
    (_ctx.mintResult)
      ? (_openBlock(), _createBlock(_component_NotifySuccess, {
          key: 1,
          class: "mt-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (!_ctx.newNFT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Loading your new NFT... This will take another minute or two. DO NOT CLOSE THIS WINDOW. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_NFTViewCard, {
                      n: _ctx.newNFT,
                      class: "text-black"
                    }, null, 8, ["n"])
                  ]))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}